import { Await, useLoaderData } from 'react-router-typesafe'
import { FormMode } from '@/enums'
import { softwareAltrePiattaformeEditorRouteLoader } from '@/routes/software/altre-piattaforme/SoftwareAltrePiattaformeEditor.route'
import { SoftwareAltrePiattaformeEditorForm } from '@/routes/software/altre-piattaforme/SoftwareAltrePiattaformeEditor.form'
import { Suspense } from 'react'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import { useFetcher } from 'react-router-dom'
import { SoftwareAltrePiattaformeEditorProps } from '@/routes/software/altre-piattaforme/SoftwareAltrePiattaformeEditor.types'
import { isUserRoleAllowed } from '@/routes/utils'
import DocumentHead from '@/components/document-head/DocumentHead'

export function SoftwareAltrePiattaformeEditor(props: SoftwareAltrePiattaformeEditorProps) {
  const {
    title,
    swLicense,
    getClients,
    getAltrePiattaformePlatforms,
    getAltrePiattaformeMaintenancePlans,
    getAltrePiattaformeRentStatus,
    getUserInfo,
    defaultCRUDAllowedRoles,
  } = useLoaderData<typeof softwareAltrePiattaformeEditorRouteLoader>()
  const fetcher = useFetcher()

  return (
    <>
      <Suspense fallback={<LoadingPanel />}>
        <Await
          resolve={Promise.all([
            getClients,
            getAltrePiattaformePlatforms,
            getAltrePiattaformeMaintenancePlans,
            getAltrePiattaformeRentStatus,
            getUserInfo,
          ])}
        >
          {([aziende, platforms, maintenancePlans, rentStatus, userInfo]) => (
            <>
              <h2>{title}</h2>
              <div id="edit-altrepiattaforme-license-container" className={`dx-card responsive-paddings`}>
                <fetcher.Form>
                  <SoftwareAltrePiattaformeEditorForm
                    license={swLicense}
                    mode={props.mode}
                    aziendaList={aziende.data.value}
                    altrePiattaformePlatforms={platforms.data.value}
                    altrePiattaformeMaintenancePlans={maintenancePlans.data.value}
                    altrePiattaformeRentStatus={rentStatus.data.value}
                    userInfo={userInfo}
                    isRoleAllowed={isUserRoleAllowed(userInfo?.roles, defaultCRUDAllowedRoles)}
                    fetcher={fetcher}
                  />
                </fetcher.Form>
              </div>
            </>
          )}
        </Await>
      </Suspense>
    </>
  )
}
